import React, {
  useRef,
  useState,
  useEffect,
  useCallback,
  useMemo,
} from "react";
import { Line, PivotControls, Center } from "@react-three/drei";
import { connect } from "react-redux";
import action from "../../../../store/action";

import * as THREE from "three";

import store from "../../../../store";

import {
  getGumData,
  getGumUrl,
  getGumMatrix,
  getGumFileType,
} from "../../../../dataInterface/index";
import Gum from "../../../../Components/CreateModal/Gum";
import { cloneDeep } from "lodash";
import GumModel from "../../../../Components/CreateModal/GumModel";
import { TOOTH_GUM_TYPE } from "../../../../data/constant/toothConstant";
import gumManager from "../../../../data/manager/gumManager";
import { getOpacity } from "../../../../common/tooth";
import { addPerform, logPerform } from "../../../../tools/perform-tool";

function GumDataPro2(props) {
  const { keyframeNumber, sliderVal, gumCheckboxValue } = props;
  const stageNumber = keyframeNumber + 1;
  const upperGumModel = gumManager.getGumModelByStageNumberAndToothGumType(
    stageNumber,
    TOOTH_GUM_TYPE.UPPER
  );
  const lowerGumModel = gumManager.getGumModelByStageNumberAndToothGumType(
    stageNumber,
    TOOTH_GUM_TYPE.LOWER
  );

  const upperGumMatrix = gumManager.getGumMatrixByStageNumberAndToothGumType(
    stageNumber,
    TOOTH_GUM_TYPE.UPPER
  );
  const lowerGumMatrix = gumManager.getGumMatrixByStageNumberAndToothGumType(
    stageNumber,
    TOOTH_GUM_TYPE.LOWER
  );

  let upperOpacity = getOpacity(TOOTH_GUM_TYPE.UPPER, sliderVal);
  let lowerOpacity = getOpacity(TOOTH_GUM_TYPE.LOWER, sliderVal);

  useEffect(() => {
    if(upperGumModel || lowerGumModel) {
      addPerform({ name: "file.loadFile.end  " });
      logPerform();
    }
  }, []);

  return (
    <>
      <group
        matrix={upperGumMatrix}
        matrixAutoUpdate={false}
        visible={gumCheckboxValue}
      >
        <GumModel model={upperGumModel} opacity={upperOpacity} />
      </group>
      <group
        matrix={lowerGumMatrix}
        matrixAutoUpdate={false}
        visible={gumCheckboxValue}
      >
        <GumModel model={lowerGumModel} opacity={lowerOpacity} />
      </group>
    </>
  );
}

const mapStateToProps = (state) => ({
  keyframeNumber: state.webViewer.keyframeNumber,
  sliderVal: state.webViewer.sliderVal,
  gumCheckboxValue: state.webViewer.gumCheckboxValue,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(GumDataPro2);
